export const setError = (state, payload) => {
  if (state && payload) {
    if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
      createPreviousStateCopy(state);
      state.error = payload;
      state.success = null;
      state.processing = false;
    }
  }
}

export const clearError = (state) => {
  if (state) {
    if (objectBulkCheckProps(state, ['error'])) {
      state.error = null;
    }
  }
}

export const setSuccess = (state, payload) => {
  if (state) {
    if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
      createPreviousStateCopy(state);
      state.error = null;
      state.success = payload;
      state.processing = false;
    }
  }
}

export const setProcessing = (state, payload) => {
  if (state) {
    if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
      createPreviousStateCopy(state);
      state.processing = payload;
    }
  }
}

function objectBulkCheckProps(object, propList) {
  if (object && Array.isArray(propList)) {
    if (propList.length > 0) {
      const result = propList
        .every(prop => Object.prototype.hasOwnProperty.call(object, prop));
      return result;
    }
  }
  return null;
}

function createPreviousStateCopy(state) {
  let previous = JSON.parse(JSON.stringify(state));
  delete state.previous;
  state.previous = previous;
}
